import styled from 'styled-components';

export const ResultTableWrapper = styled.div`
    overflow-x: auto;
    margin: 20px 0;
    width: 100%;
`;